<div class="cr-button-wrapper" *appRequiredPerms="requiredPermissions" [ngClass]="cssClasses">
  <button
    class="cr-button"
    [disabled]="isDisabled || isLoading"
    [class.disabled]="isDisabled || isLoading"
    [class.loading]="isLoading"
    [routerLink]="goBack ? null : routerLink"
    (click)="onClick()">
    <span class="label">
      <ng-content></ng-content>
    </span>

    <ng-container *ngIf="isLoading">
      <span class="overlay-spinner">
        <span class="spinner"></span>
      </span>
    </ng-container>
  </button>
</div>
